import { cn } from '@/lib/utils';
import { formatTime } from '@/lib/utils';
import { Badge } from '@/components/ui/Badge';

interface DealCardProps {
  dealName: string;
  originalPrice: number;
  currentDiscount: number;
  tierLabel: string;
  tierColor: string;
  timeRemaining: number;
  compact?: boolean;
}

export function DealCard({
  dealName,
  originalPrice,
  currentDiscount,
  tierLabel,
  tierColor,
  timeRemaining,
  compact = false,
}: DealCardProps) {
  const discountedPrice = originalPrice * (1 - currentDiscount / 100);

  return (
    <div
      className={cn(
        'rounded-2xl border border-white/10 bg-white/5 backdrop-blur-md',
        compact ? 'p-4' : 'p-6',
      )}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0 flex-1">
          <h3
            className={cn(
              'truncate font-semibold text-white',
              compact ? 'text-sm' : 'text-lg',
            )}
          >
            {dealName}
          </h3>
          <div className={cn('mt-1 flex items-baseline gap-2', compact && 'mt-0.5')}>
            <span
              className={cn(
                'font-bold text-white',
                compact ? 'text-lg' : 'text-2xl',
              )}
            >
              ${discountedPrice.toFixed(2)}
            </span>
            <span
              className={cn(
                'text-gray-400 line-through',
                compact ? 'text-xs' : 'text-sm',
              )}
            >
              ${originalPrice.toFixed(2)}
            </span>
          </div>
        </div>
        <Badge color={tierColor}>{tierLabel}</Badge>
      </div>

      <div
        className={cn(
          'flex items-center justify-between border-t border-white/10 text-gray-400',
          compact ? 'mt-3 pt-3 text-xs' : 'mt-4 pt-4 text-sm',
        )}
      >
        <span>{currentDiscount}% off</span>
        <span className="tabular-nums">{formatTime(timeRemaining)}</span>
      </div>
    </div>
  );
}
